import { render, staticRenderFns } from "./ImageContextMenu.vue?vue&type=template&id=6c5094a4&scoped=true&"
import script from "./ImageContextMenu.vue?vue&type=script&lang=ts&"
export * from "./ImageContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ImageContextMenu.vue?vue&type=style&index=0&id=6c5094a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5094a4",
  null
  
)

export default component.exports